export const MAIN_ROUTE = '/';
export const LOGIN = '/login';

export const NEW_LOGIN = '/login';
export const NEW_SIGNUP = '/signup';

export const FORGOT_PASSWORD = '/forgot_password';
export const VERIFY_RESET_TOKEN = '/verifyResetToken';
export const REQUEST_DEMO = '/demo';

// export const WORKSPACE = "/workspace";
export const WORKSPACE = '/';
export const AI_CODING = '/ai-coding';
export const AI_CODING_LEGACY = '/quicktag';
export const LIBRARIES = '/libraries';
export const USERS = '/users';
export const INVITED_USER = USERS + '/invited';

export const HOME_PAGE = '/home';
export const CLIENTS = '/clients';
export const EDIT_PROFILE = '/me';
export const PROJECTS = '/projects';
export const OPTION_PACKS = '/libraries/optionpacks';
export const NEW_OPTION_PACK = OPTION_PACKS + '/new';
export const INVITATION = '/invitation/validate';

// Overview
export const PROJECT = `/projects`;
export const NEW_PROJECT = `/projects/new`;
export const PROJECT_SELECTION = `/projects/new/select`;
export const EDIT_NEW_PROJECT = `/projects/:projectId`;

export const AUDIENCE = `/projects/:projectId/audience`;

export const PREVIEW = `/projects/:projectId/preview`;

export const QUESTIONS = `/projects/:projectId/questions`;
export const EDIT_QUESTIONS = `/projects/:projectId/questions`;
export const LAUNCH_PROJECT = `/projects/:projectId/launch`;

export const MEDIA_LIBRARY = '/libraries/media';
export const QUESTION_LIBRARY = '/libraries/questions';

export const MANAGE_PROFILE = '/manage-profile';
export const MY_ACCOUNTS = MANAGE_PROFILE + '/my-accounts';

export const MANAGE_ACCOUNTS = '/manage-accounts';
export const PLAN_AND_BILLING = MANAGE_ACCOUNTS + '/plan-billing';
export const CHECKOUT = `/projects/:projectId/checkout`;

// error
export const PAGE_NOT_FOUND = '/404';
